import React, { useRef, useMemo } from "react";
import { Spin, Alert as AlertAntd, Typography } from "antd";
import { JoinedAlert } from "../../../types";
import AlertDialog from "./AlertDialog";
import { useListTrapSitesQuery } from "../../../actions/trapsiteInQuery";
import { useListDevicesQuery } from "../../../actions/devicesInQuery";
import { DownOutlined } from "@ant-design/icons";
import "./index.css";
import { ReactComponent as MosquitoIconSvg } from "../../../assets/icons/MosquitoVector.svg";
import { useAppAlerts } from "../../../hooks/useAppAlerts";

const { Title, Text } = Typography;

type Props = {
  // Extra props go here
};

const DetectionAlert: React.FC<Props> = () => {
  const { data: alerts } = useAppAlerts();

  const { data: trapSiteData, isLoading: trapSiteLoading } =
    useListTrapSitesQuery();
  const { data: devices, isLoading: devicesLoading } = useListDevicesQuery();

  const listContainerRef = useRef<HTMLDivElement>(null);

  const joinedAlerts = useMemo(() => {
    if (!alerts?.items) {
      return [];
    }

    let result: JoinedAlert[] = [];

    alerts?.items.forEach((alert) => {
      if (alert.tag !== "Detection") {
        return;
      }
      const device = devices?.items?.find((d) => d.uuid === alert.device);
      const trapSite = trapSiteData?.items?.find((t) => {
        return t._id === device?.trap_id;
      });
      result.push({
        ...alert,
        device_name: device?.display_name || "",
        trap_name: trapSite?.display_name || "",
      });
    });

    return result;
  }, [alerts, devices, trapSiteData]);

  return (
    <div className="detection-box-container">
      <Spin spinning={trapSiteLoading || devicesLoading}>
        <div className="detection-box-title">
          <Title level={4} className="detection-box-title-text">
            Detections
          </Title>
          <DownOutlined className="detection-box-title-icon" />
        </div>
        <div
          ref={listContainerRef}
          className={`detection-box-alerts ${
            joinedAlerts.length > 0 ? "has-alerts" : "no-alerts"
          }`}
        >
          {joinedAlerts.length > 0 ? (
            joinedAlerts.map((item: JoinedAlert) => (
              <AlertDialog
                key={item._id}
                item={item}
                //   onClick={doUpdateAlert}
              />
            ))
          ) : (
            <AlertAntd
              message={<Text strong>No detections</Text>}
              showIcon
              type="success"
              icon={
                <MosquitoIconSvg
                  width={24}
                  height={24}
                  stroke="none"
                  fill="#22C55E"
                />
              }
            />
          )}
        </div>
      </Spin>
    </div>
  );
};

export default DetectionAlert;
